import React from 'react';
import { AppRouter } from './routes/AppRouter';
import './styles/styles.scss';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { CookiesProvider } from 'react-cookie';
import { createRoot } from 'react-dom/client';
const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <CookiesProvider>
      <AppRouter />
    </CookiesProvider>
  </React.StrictMode>
);
